import Button from './button';

import Arrow from './arrow';

export default function ButtonProceed(props) {
    const { 
        children,
     } = props;

    return <Button { ...props } className="button--blue" rightIcon={<Arrow rotate='-90deg'/>}>{ children ? children : 'Proceed' }</Button>
}